export const isSafariBrowser = (): boolean => !!navigator.userAgent.match(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari/);
